/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import {
  oneOf,
  bool as boolType,
  string as stringType,
  number as numberType,
} from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import className from 'classnames';
import {
  shouldLoadFromStorage,
  transformDataForStorage,
} from '../utils/recently-viewed';
import { isLoading } from '../utils/helpers';
import { RecommendationsProductPodCarousel } from '../core/RecommendationsProductPodCarousel';
import { rvDataModel } from '../dataModel';
import { FallbackCard } from '../core/FallbackCard';

const RecentlyViewed = (props) => {
  const {
    brandTitleMaxLine,
    hideRating,
    hideTitle,
    schemaName,
    showLoading,
    hideATC,
    slidesPer,
    showFallback
  } = props;

  const { storeId, storeZip: zipCode, isLocalized } = useStore();
  // const [productData, setProductData] = useState([]);

  const THDCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : {};
  const userId = THDCustomer.svocID || THDCustomer.userID || THDCustomer.guestUserID;
  const pAPIKey = '2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg'; // TODO - THIS IS TEMP - This will change to 4 diff keys

  /* const processData = (data) => {
    const transformedData = transformDataForStorage(data);

    setProductData(transformedData);
  }; */

  const opts = {
    variables: {
      storeId,
      key: pAPIKey,
      dataSource: schemaName,
      userId,
      unique: true,
      zipCode,
      apiName: 'views',
      skipSpecificationGroup: true,
      skipKPF: true,
      skipInstallServices: true,
      skipSubscribeAndSave: true
    },
    persist: {
      storage: 'sessionStorage',
      expirationInSeconds: 5 * 60
    },
    skip: !isLocalized || !userId,
    ssr: false,
    // Force new request if we should not load from storage/cache
    fetchPolicy: isLocalized && !shouldLoadFromStorage() ? 'network-only' : 'cache-first'
  };

  const { loading: recsLoading, data: recsData, error: recsError } = useDataModel('uds', opts);

  /*  useEffect(() => {
    if (recsData?.uds && !recsError) {
      processData(recsData);
    }
  }, [recsData]);
 */

  const wrapperClasses = className(
    'uds',
    schemaName,
    {
      loading: showLoading && recsLoading,
    }
  );

  if (recsError || (recsData !== undefined && (!recsData || !recsData?.uds) && !recsLoading)) {
    if (showFallback) {
      return (
        <FallbackCard
          imageUrl="https://assets.thdstatic.com/images/v1/online-shopping.svg"
          header="Get Back to Shopping"
          subheader="Check out our weekly ad for the latest sales"
          footerUrl="https://www.homedepot.com/c/localad"
          footer="Browse Weekly Ad"
        />
      );
    }

    return null;
  }

  return (
    <Row>
      <Col id={schemaName} className={wrapperClasses} data-type="container">
        <meta data-prop="name" content={schemaName} />
        <RecommendationsProductPodCarousel
          brandTitleMaxLine={brandTitleMaxLine}
          itemClass="fixed-item"
          storeId={storeId}
          zipCode={zipCode}
          scheme={schemaName}
          showLoading={showLoading}
          title="Recently Viewed"
          hideRating={hideRating}
          hideSavingsText
          hideShopThisCollection
          hideShippingInfo
          hideFavorites
          hideATC={hideATC}
          hideTitle={hideTitle}
          loadingImageHeight={250}
          loadingLinesCount={10}
          data={recsData?.uds}
          loading={isLoading(recsData, recsLoading)}
          shouldSkip={() => shouldLoadFromStorage()}
          slidesPer={slidesPer}
        />
      </Col>
    </Row>
  );
};

RecentlyViewed.dataModel = rvDataModel;

RecentlyViewed.displayName = 'RecentlyViewed';

RecentlyViewed.propTypes = {
  // product-pod take only these values for brandTitleMaxLine prop
  brandTitleMaxLine: oneOf([2, 3, null]),
  hideRating: boolType,
  showLoading: boolType,
  schemaName: stringType.isRequired,
  hideATC: boolType,
  hideTitle: boolType,
  slidesPer: numberType,
  showFallback: boolType
};

RecentlyViewed.defaultProps = {
  brandTitleMaxLine: null,
  hideRating: false,
  showLoading: true,
  hideATC: true,
  hideTitle: false,
  slidesPer: null,
  showFallback: false
};

export default RecentlyViewed;
